import { render, staticRenderFns } from "./Sreen_report.vue?vue&type=template&id=1f4ae692&scoped=true"
import script from "./Sreen_report.vue?vue&type=script&lang=js"
export * from "./Sreen_report.vue?vue&type=script&lang=js"
import style0 from "./Sreen_report.vue?vue&type=style&index=0&id=1f4ae692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4ae692",
  null
  
)

export default component.exports